export default [
  {
    header: 'ClientPortal.SideMenu.Account',
  },
  {
    title: 'ClientPortal.SideMenu.Balance',
    route: 'balance',
    icon: 'Payment',
  },
  {
    title: 'ClientPortal.SideMenu.Settings',
    route: 'settings',
    icon: 'Settings',
  },
]
